import {RATINGS_DATA_UPLOAD_RESPONSE} from './action';

const ratingsDataUploadReducer = (state = {}, action) => {
    switch (action.type) {
        case RATINGS_DATA_UPLOAD_RESPONSE:
            return state = {
                ...state,
                ratingsDataUploadResponse: action.data
            }
        default: return state
    }
};

export default ratingsDataUploadReducer;